import axios from 'axios'
import {
	message
} from 'ant-design-vue';
import store from '@/store'

import router from '@/routers/index'

// create an axios instance
const service = axios.create({
	baseURL: '/', // url = base url + request url
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 30 * 1000, // request timeout
	withCredentials: true
})

// request interceptor
service.interceptors.request.use(
	config => {
		const token = window.localStorage.getItem("TOKEN")
		if (token) {
			config.headers['Authorization'] = 'Bearer ' + token
		}

		return config
	},
	error => {
		// do something with request error
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		const res = response.data
		// console.log(res)
		if (res.code !== 1) {
			message.error(res.msg || 'Error');
			console.error(res.msg)
			return Promise.reject(res.msg || 'Error')
		} else {
			return res.data
		}
	},
	error => {
		console.error(error)
		if (!error.response.data || !error.response.data.msg) {
			message.error('网络异常');
			return Promise.reject(error)
		}
		const errorMsg = error.response.data.msg
		const errorCode = error.response.data.code
		console.error(errorCode, error.response.data)
		if (errorCode === 401000) { // token过期

			store.dispatch('user/logout').then(() => {
				router.replace({
					path: '/login'
				})
			})
			message.error('登录超时，请重新登录');
			return
		}

		message.error(errorMsg ?? error);
		return Promise.reject(error)
	}
)

export default service
